import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useState, useEffect } from 'react';

export const ConfirmCode = ({ verfy2FA, data2FA, handleChange2FA, submitVerify2FA, sendEmailCodeAgain, submitChange2FAMethod, scanAgain, isInAdmin }) => {
    const [timer, setTimer] = useState(60); 
    const [isButtonEnabled, setIsButtonEnabled] = useState(false);

    useEffect(() => {
        if (!isButtonEnabled) {
            const timerId = setInterval(() => {
                setTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(timerId);
                        setIsButtonEnabled(true); 
                        return 60; 
                    }
                    return prev - 1; 
                });
            }, 1000);

            return () => clearInterval(timerId); 
        }
    }, [isButtonEnabled]);

    const modifyEmailString = () => {
        const [localPart, domain] = verfy2FA.email.split('@');
        if (localPart.length > 1) {
            const obfuscatedLocalPart = localPart[0] + '*'.repeat(localPart.length - 2) + localPart[localPart.length - 1];
            return `${obfuscatedLocalPart}@${domain}`;
        }
        return verfy2FA.email;
    }

    const sendCodeAgain = (e) => {
        sendEmailCodeAgain(e); 
        setIsButtonEnabled(false); 
        setTimer(60);
    }

    let emailWithStars = '';

    if (verfy2FA.type2FA == 3) {
        emailWithStars = modifyEmailString();
    }

    return (
        <div className="form-group">
            <div className="input-group d-flex justify-content-center flex-wrap">
                <div className={`${isInAdmin ? 'w-100' : ''} text-center d-flex gap-2 justify-content-center flex-wrap`}>
                    {verfy2FA.type2FA == 3
                        ? <p className='w-100 text-start'>За да продължите, моля въведете го в предоставеното поле. Кодът е изпратен на посоченият от Вас email адрес <b className="btn-link-email">{emailWithStars}</b>. Ако не сте го получили, първо проверете в папката Spam(Trash), а след това поискайте изпращането на нов.</p>
                        : verfy2FA.type2FA == 2
                            ? <p className='w-100 text-start'>За да продължите, моля въведете кода от приложението за двуфакторна автентикация с което сте се сдвоили в полето</p>
                            : null}
                    {verfy2FA.type2FA == 3 && <button
                        className="btn-link-email p-0 text-start w-100"
                        onClick={sendCodeAgain}
                        disabled={!isButtonEnabled} // Disable button based on state
                    >
                        {isButtonEnabled ? "Поискайте нов код" : `Ще можете да поискате нов код след ${timer} секунди`}
                    </button>}
                    <InputText name='code' id="code" style={{ width: '100%' }} placeholder="Код"  value={data2FA.code} onChange={handleChange2FA} />
                    <Button
                        label="Потвърди"
                        icon="pi pi-check"
                        severity="danger"
                        raised
                        className='btn-prim-confirm w-100 w-100-mob'
                        onClick={submitVerify2FA}
                    />
                    {!isInAdmin &&
                        <div className='w-100 mt-4'>
                            <button className="p-0 m-0 btn-link-email" onClick={submitChange2FAMethod}>Изберете друг метод за вход</button>
                        </div>
                    }
                </div>

            </div>

            {/*{verfy2FA.type2FA == 2 &&*/}
            {/*    <p>Сканирай или въведи кода за Google/Microsoft Authenticator отново от <button className="btn-link" onClick={scanAgain}>ТУК</button></p>*/}
            {/*}*/}
        </div>
    )
}